import React from "react"

export default class Comments extends React.Component {
	
	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<div className="Comments">
				<textarea name={this.props.question.id} value={this.props.value} placeholder={this.props.placeholder} onChange={this.onChange} />
			</div>
		);
	}

	onChange(e) {
		e.stopPropagation();
		e.preventDefault();

		this.props.onChange('COMMENTS', this.props.question.id, {text: e.target.value})
	}

}